import { apiClient } from '@app/lib'
import { useSugarContext } from '@app/providers'
import { type SugarProviderProfileResponse } from '@app/types'
import { useQuery } from '@tanstack/react-query'
import ms from 'ms'
import { useSession } from 'next-auth/react'

export const useProviderProfile = () => {
  const session = useSession()
  const { siteId } = useSugarContext()

  return useQuery({
    enabled: session.status === 'authenticated' && Boolean(siteId),
    queryKey: ['provider-profile', { siteId }],
    queryFn: async ({ signal }) => {
      const { data } = await apiClient.get<SugarProviderProfileResponse>(`/api/provider-profile`, {
        params: {
          siteId
        },
        signal
      })

      return data.data
    },
    staleTime: ms('1h')
  })
}
